import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { GalavailServiceEcommer } from "clientwsGalavail";
import * as $ from "jquery";
import { Geoip2Service, NgWebflowService, ServerDateService } from "ngweflow";
import { Availability } from "src/app/models/availability";
import { PaymentMethod } from "src/app/models/payment-method";
import { PaypalPaymentResponse } from "src/app/models/paypal/paypal-payment-response";
import { Purchase } from "src/app/models/purchase";
import { BookingConfirmationResponse } from "src/app/models/purchase/booking-confirmation-response";
import { UnblockDeparture } from "src/app/models/purchase/unblock-departure";
import { TransactionResponseInterface } from "src/app/ngGtcPayflow/classes/transaction-response.interface";
import { RoyalRequestService } from "src/app/services/royal-request/royal-request.service";
import { UtilsService } from "src/app/shared/services/utils.service";
import { isNullOrUndefined } from "util";
import { environment } from "../../../../environments/environment";
import { CodeProcesscrmEnum } from "../../../enums/code-process-crm.enum";
import { PaymentMethodTransfer } from "../../../enums/payment-method-transfer.enum";
import { PaymentMethodTypeEnum } from "../../../enums/payment-methods-type.enum-";
import { ResponseOnHold } from "../../../enums/response-on-hold.enum";
import { PaymentsType } from "../../../models/payments-type";
import { IStripe } from "../../../models/request-stripe";
import { PaymentsTypeService } from "../../../services/payments-type/payments-type.service";
import { CheckoutStripeService } from "../../../shared/services/checkout-stripe.service";
import { ContactFormService } from "../../services/contact-form/contact-form.service";
import { CruiseService } from "../../services/cruise/cruise.service";
import { PromoService } from "../../services/promo/promo.service";
import { PurchaseRequestService } from "src/app/reserve/services/purchase-request/purchase-request.service";
import { PaymentType } from "./../../../enums/payment-type.enum";
import { PurchaseRequestStatus } from "./../../../enums/purchase-request-status.enum";
import { BlockDeparture } from "./../../../ngGtcPayflow/models/block-departure";
import { CompanyParamsService } from "./../../../services/companyParams/company-params.service";
import { UrlParamsService } from "./../../../services/url-params.service";
import { ReservationClass } from "src/app/classes/reservation.class";
import { PlacetopayComponent } from "../payment-options/components/placetopay/placetopay.component";
declare let paypal: any;
import * as Cookies from "es-cookie";
import { WebFlowAction } from "src/app/enums/web-flow-action.enum";
import { PaymentOption, ConfiguracionPagoTarjeta } from '../payment-options/commons/parameters';
import { AuditStep, StripeService } from '../payment-options/services/stripe.service';
import { PlacetopayService, PlacetopayProcessResult, PlacetopayCreateSessionRequest, PlacetopayPaymentStatus, PlacetopayInvocationContext } from '../payment-options/services/placetopay.service';
import { Location } from '@angular/common';
import { MerchantNotificationRequest } from "src/app/models/placetopay/merchant-notification-request";
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: "app-checkout-third",
  templateUrl: "./checkout-third.component.html",
  styleUrls: ["./checkout-third.component.css"],
  animations: [
    trigger('selectionAnimation', [
      state('selected', style({
        transform: 'scale(1)',
        opacity: 1
      })),
      state('unselected', style({
        transform: 'scale(1)',
        opacity: 1
      })),
      transition('unselected => selected', [
        animate('0.3s ease-out', style({
          transform: 'scale(1.02)',
        })),
        animate('0.2s ease-in', style({
          transform: 'scale(1)',
        }))
      ]),
      transition('selected => unselected', [
        animate('0.2s ease-out')
      ])
    ]),
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0',
        opacity: 0,
        padding: '0 10px',
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        padding: '10px',
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('0.4s cubic-bezier(0.4, 0, 0.2, 1)')
      ])
    ])
  ]
})
export class CheckoutThirdComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('placetopayLightbox') placetopayComponent: PlacetopayComponent;

  public isBlockDepartureSuccess: boolean;
  public activeEndSlide: string;
  public purchaseTotalPrice;
  public comment1: string;
  private isConsoleLog: boolean;
  public paymentType = PaymentType;
  public isPaymentComplete: boolean;
  public isPaymentCancel: boolean;
  public isPaymentError: boolean;
  public isProcessing: boolean = false;
  public cruise: any;
  public startEndDates: string;
  public startEndDatesType: string;
  public promotion: string;
  public priceWithAirFare: number;
  public itineraryIndex: number;
  public cruiseStartDate: string;
  public boatImagesResource: string;
  public isRequestingBlockDeparture: boolean;
  public position: boolean;
  public cruiseItineraryDuration: string;
  public isAutoPaymentAccepted: boolean;
  public minDepartureTimeToEnableAutoPayment: number;
  public termsCondition: boolean;
  public hasThirtyPercent: boolean;
  public valueTerms = "none";
  isSelectedThirtyPercent = false;
  allValuePrice: number;
  onlyThirtyPrice: number;
  termsConditionPaytransfer: boolean;
  termsPrivacyData: boolean;
  flagClick = false;
  availavilitySelected: Availability;
  geoIp = "";
  urlElementsArray: string[] = [];
  isProcessingStripe = false;
  successStripe: boolean = false;
  failureStripe = false;
  monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  counterSuccessAutomaticEmail: number = 0;
  paymentMethods: PaymentMethod[];
  reservationClass = new ReservationClass();
  whatsappNumber:any;

  public attemptPaymentStripe = 0;
  public typeErrorPaymentStripe = ResponseOnHold.INIT_ERROR;
  public paymentOption = PaymentOption.NONE;
  public paymentOptionEnum = PaymentOption;
  public paymentMethodTypeEnum = PaymentMethodTypeEnum;
  public PlacetopayInvocationContext = PlacetopayInvocationContext;

  // PlaceToPay variables
  public placetopayResult: PlacetopayProcessResult | null = null;
  public placetopayLoading: boolean = false;
  public placetopaySessionId: string = '984561'; // ID de sesión por defecto
  public placetopayInvocationContext: PlacetopayInvocationContext = PlacetopayInvocationContext.LIGHTBOX;
  public placetopayPaymentRequest: MerchantNotificationRequest | null = null;
  // true mientras se espera el resultado del servicio de consulta (pago PENDING en polling).
  // El mensaje de intentos excedidos solo se muestra cuando esta espera termina.
  public placetopayWaitingStatus: boolean = false;
  public attemptPaymentPlacetopay: number = 0;
  public placetopayPaymentApproved: boolean = false; // Bandera para indicar que el pago fue aprobado
  public placetopayPaymentErrorBlock: boolean = false; // Bandera para mostrar mensaje de error específico de PlaceToPay
  private isReturnFromExternalRedirect: boolean = false; // Bandera para indicar si viene desde redirección externa de PlaceToPay
  selectedCodePayment: PaymentMethod;
  public placetopayOnHoldResponse: boolean = true;
  private placetopayPollingInterval: any = null;

  constructor(
    private router: Router,
    public purchaseRequestService: PurchaseRequestService,
    private galavailServiceEcommer: GalavailServiceEcommer,
    private cruiseService: CruiseService,
    private ngWebflowService: NgWebflowService,
    private serverDateService: ServerDateService,
    private contactFormService: ContactFormService,
    private urlParamsService: UrlParamsService,
    public companyParamsService: CompanyParamsService,
    private promoService: PromoService,
    private royalRequestService: RoyalRequestService,
    private paymentsTypeService: PaymentsTypeService,
    private stripeService: StripeService,
    private placetopayService: PlacetopayService,
    private location: Location,
    private geoip2Service: Geoip2Service,
  ) {
    this.isConsoleLog = environment.console_log;
    this.hasThirtyPercent = false;
    this.allValuePrice = 0;
    this.onlyThirtyPrice = 0;
    $(document).ready(function () {
      $("html, body").animate(
        {
          scrollTop: $("#startCheckoutThird").offset().top,
        },
        1000
      );
    });
    this.royalRequestService.getGeoIpDirection().subscribe((ip) => {
      this.geoIp = ip;
    });
  }

  ngOnInit() {
    this.counterSuccessAutomaticEmail = 0;
    if (!isNullOrUndefined(this.purchaseRequestService.purchase.cruise)) {
      this.isOnTimeToPay();
      this.activeEndSlide = "active";
      this.isSelectedThirtyPercent = false;
      this.purchaseRequestService.setIsSelectedThirtyPerent(
        this.isSelectedThirtyPercent
      );
      const selecteIndex = 0;
      this.paymentMethods = this.companyParamsService.getPaymentMethods();
      this.paymentMethods.forEach((item, index) => {
        item.selected = false;
      });
      this.cruise = this.purchaseRequestService.purchase.cruise;
      this.availavilitySelected = this.cruise.availability[selecteIndex];
      this.purchaseTotalPrice = this.purchaseRequestService.getTotalPrice();
      this.allValuePrice = this.purchaseRequestService.getTotalPrice();
      this.onlyThirtyPrice = Math.round(
        this.allValuePrice *
          (this.companyParamsService.getPercentPartialPayment() / 100)
      );
      this.cruiseStartDate =
        this.cruise.availability[this.cruise.iterIndex].date;
      this.startEndDates =
        this.cruise.availability[this.cruise.iterIndex].startEndDates;
      this.startEndDatesType =
        this.cruise.availability[this.cruise.iterIndex].name;
      this.promotion =
        this.cruise.availability[this.cruise.iterIndex].promotion;
      this.itineraryIndex = selecteIndex;
      this.priceWithAirFare = this.cruiseService.getCruisePriceinNewFormat(
        this.cruise,
        this.itineraryIndex,
        true
      );
      this.initializeBoatImageResource();
      this.position = true;
      this.cruiseItineraryDuration = this.purchaseRequestService
        .getCruiseWrapper()
        .getCruiseItineraryDuration();
      this.isAutoPaymentAccepted =
        this.purchaseRequestService.isAutoPaymentAccepted();

      this.minDepartureTimeToEnableAutoPayment =
        environment.PURCHASE.MIN_TIME_TO_ENABLE_AUTOPAYMENT;
    } else {
      // Verificar si estamos en la ruta /success (callback de pago)
      const currentUrl = this.router.url;
      if (currentUrl.includes('/success') || currentUrl.includes('/cancel')) {
        console.log('Detected return from PlaceToPay success callback.');
        // Intentar restaurar datos desde sessionStorage
        const purchaseRestored = this.purchaseRequestService.restorePurchaseFromSession();
        const companyRestored = this.companyParamsService.restoreCompanyFromSession();

        if (purchaseRestored && companyRestored) {
          // Datos restaurados exitosamente, inicializar el componente normalmente
          this.initializeFromRestoredData();
        } else {
          // No hay datos guardados, mostrar estado de pago completado genérico
          this.isPaymentComplete = true;
          this.activeEndSlide = "active";
          this.goError();
        }
        // Consultar estado del pago en PlaceToPay
        this.checkPlacetopayPaymentStatus();
      } else {
      window.location.href = window.location.href.substring(0, window.location.href.length -1);
    }
    this.whatsappNumber = this.companyParamsService.getCompanyParams() ? this.companyParamsService.getCompanyParams().whatsappNumber : null;
  }
  }
  ngAfterViewInit(): void {
    if (this.isAutoPaymentAccepted === true) {
      this.renderPaypalButton("paypal-button-payment", false, "paypal");

      // this.renderPaypalButton('paypal-button-funding-buttons', true, 'buynow');
    }
  }
  ngOnDestroy(): void {
    this.stopPlacetopayStatusPolling();
    /*
    this.isSelectedThirtyPercent = false;
    this.purchaseRequestService.setIsSelectedThirtyPerent(
      this.isSelectedThirtyPercent
    );
    this.purchaseTotalPrice = this.purchaseRequestService.getTotalPrice();*/
  }
  createUrlLogoCruise() {
    return environment.app_resources.logoCruise + this.cruise.logo;
  }
  nextFourthPart() {
    this.router.navigate([this.urlParamsService.createurlForNextPage("4")]);
  }
  onErrorCreditCardPayment(event) {}
  alertTerms() {
    alert("Please accept terms and conditions");
  }

  /** Este metodo esta comentado debido a q sirve unicamente para probar el servicio de bloque*/
  public async blockCabinNewjson(test?) {
    this.isProcessing = true;
    try {
      await this.setTransactionCode();
    } catch (error) {
      return new Error("err");
    }
    this.purchaseRequestService
      .requestBlockCabinOnHold(this.purchaseRequestService.getPercentUsed())
      .subscribe(
        (blockDepartureResponse: BlockDeparture) => {
          const isblockDeparture: boolean =
            this.purchaseRequestService.setBlockDeparture(
              blockDepartureResponse
            );
          this.isBlockDepartureSuccess =
            isblockDeparture === true &&
            this.purchaseRequestService.isRequestBlockDepartureSuccess();
          if (this.isBlockDepartureSuccess === false) {
            this.cabinWasReservedOrHttpError(ResponseOnHold.RESERVED_ERROR);
            this.isBlockDepartureFailed();
          } else {
            //this.requestPostSpaces();
            this.isPaymentComplete = true;
            this.isPaymentCancel = false;
            this.isPaymentError = false;
            this.purchaseRequestService.purchaseRequestStatus =
              PurchaseRequestStatus.PAYMENT_COMPLETED;
            this.addlog(
              WebFlowAction.EXECUTING_PAYMENT_SUCCESS,
              //"completed",
              "ok",
              );
            this.requestBookingConfirmation();
          }
          this.isRequestingBlockDeparture = false;
        },
        (error) => {
          this.isRequestingBlockDeparture = false;
          this.isBlockDepartureSuccess = false;
          this.addlog(
            WebFlowAction.ON_HOLD,
            //"error",
            error
            );
          console.log("PaymentOptionsComponent.blockDeparture()");
          console.error(error);
          this.isBlockDepartureFailed();
          this.cabinWasReservedOrHttpError(ResponseOnHold.HTTP_ERROR);
        },
        () => {
          this.isRequestingBlockDeparture = false;
        }
      );
  }

  async setTransactionCode() {
    try {
      const response: any = await this.purchaseRequestService
        .requestStatusAvailability(this.purchaseRequestService.getPercentUsed())
        .toPromise();

      this.purchaseRequestService.setValueTransaction(response.message);
    } catch (error) {
      this.errorProcess(error);
      throw new ReferenceError("falied code transaction");
    }
  }

  errorProcess(error: any) {
    this.isRequestingBlockDeparture = false;
    this.isBlockDepartureSuccess = false;
    console.log("PaymentOptionsComponent.blockDeparture()");
    console.error(error);
    this.isBlockDepartureFailed();
    this.cabinWasReservedOrHttpError(ResponseOnHold.HTTP_ERROR);
  }

  async requestRoyalForm(isVoerTime: boolean) {
    if (this.companyParamsService.getName() === "Royal Galapagos") {
      this.isProcessing = true;

      this.addlog(
        WebFlowAction.SEND_CRM_REQUEST_START, this.reservationClass.formReservation );
      this.getUrlRequest(isVoerTime);
      this.royalRequestService.requestPost(this.reservationClass.formReservation).subscribe(
        (err) => {
          this.addlog(
            WebFlowAction.SEND_CRM_REQUEST_FAILED,
            //"crm",
            err
            );
          this.nextFourthPart();
        },
        () => {
          this.addlog(
            WebFlowAction.SEND_CRM_REQUEST_SUCCESS,
            //"sent",
            { result: "OK-fromPaymentOptions", json: this.reservationClass.formReservation },

          );
          this.nextFourthPart();
        }
      );
    } else {
      this.nextFourthPart();
    }
  }

  async requestRoyalFormOverTime(isOVerTime: boolean) {
    if (this.companyParamsService.getName() === "Royal Galapagos") {
      this.getUrlRequest(isOVerTime);
      this.royalRequestService.requestPost(this.reservationClass.formReservation).subscribe(
        (err) => {
          this.ngWebflowService.addWebFlowAction(WebFlowAction.SEND_CRM_REQUEST_FAILED, {
            result: err,
            json: this.reservationClass.formReservation,
          });
        },
        () => {
          this.ngWebflowService.addWebFlowAction(WebFlowAction.SEND_CRM_REQUEST_SUCCESS, {
            result: "OK-fromPaymentOptions",
            json: this.reservationClass.formReservation,
          });
        }
      );
    }
  }
  getUrlRequest(isOVerTime: boolean): string {
    let cruiseIndex = this.cruise.iterIndex;
    const startDate = new Date(this.cruise.availability[cruiseIndex].startDate);
    const endDate = new Date(this.cruise.availability[cruiseIndex].endDate);
    const promoText =
      this.getPromoName(cruiseIndex) === "0"
        ? "Regular Rate"
        : this.getPromoName(cruiseIndex);
    const newLetter = "0";

    this.urlElementsArray = [];
    let urlFinal = environment.pathCRMroyal;

    this.getStringFormDatailRoyal(promoText);

    this.getStringTravelDataRoyal(startDate, endDate, isOVerTime);
    this.getInterestDataRoyal();
    this.getContactInfoRoyal();
    this.setUtms();
    this.urlElementsArray.push(newLetter);
    this.reservationClass.formReservation.intnews = newLetter;

    this.urlElementsArray.push(this.geoIp);
    this.reservationClass.formReservation.varip = this.geoIp;

    this.setLastFourItmes(isOVerTime);
    const urlEscapedElementsArray = this.urlElementsArray.map(
      (urlElement: string) => {
        return encodeURIComponent(urlElement);
      }
    );
    this.reservationClass.formReservation.category = this.cruise.category.toString();
    this.reservationClass.formReservation.product = this.cruise.name.toString();
    urlFinal += urlEscapedElementsArray.join("/");
    return urlFinal;
  }
  setLastFourItmes(isOverTime: boolean) {
    this.urlElementsArray.push(this.isMobile());
    this.reservationClass.formReservation.device = this.isMobile();
    this.urlElementsArray.push("Not specific");
    this.urlElementsArray.push("Not specific");
    this.reservationClass.formReservation.codeType = isOverTime
      ? CodeProcesscrmEnum.RG_NP_AV
      : CodeProcesscrmEnum.RG_VECOM;
    this.urlElementsArray.push(
      isOverTime ? CodeProcesscrmEnum.RG_NP_AV : CodeProcesscrmEnum.RG_VECOM
    );
  }

  isMobile() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "Tablet";
    } else if (
      /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "Mobile";
    } else {
      return "Desktop";
    }
  }

  getStringTravelDataRoyal(
    startDate: Date,
    endDate: Date,
    isOVerTime: boolean
  ): string {
    let arrivalDate = "";
    let departureDate = "";
    let daysCruise = this.availavilitySelected.length.substring(0, 1);
    let optionCruise = this.availavilitySelected.name
      .substring(this.availavilitySelected.name.length, 1)
      .trim();
    let numberAdults = this.purchaseRequestService.getNumberOfAdults();
    let numberChild = this.purchaseRequestService.getNumberOfChildren();
    let comments =
      this.purchaseRequestService.getPurchaseContactPerson().remarks === ""
        ? "None specific"
        : this.purchaseRequestService.getPurchaseContactPerson().remarks;
    const dayString =
      startDate.getDate() < 10
        ? "0" + String(startDate.getDate())
        : String(startDate.getDate());
    const endDayString =
      endDate.getDate() < 10
        ? "0" + String(endDate.getDate())
        : String(endDate.getDate());

    arrivalDate = `${
      this.monthNames[startDate.getMonth()]
    } ${dayString}, ${startDate.getFullYear()}`;
    departureDate = `${
      this.monthNames[endDate.getMonth()]
    } ${endDayString}, ${endDate.getFullYear()}`;
    const automaticTextNotification = isOVerTime
      ? "WITHIN 72 HOURS"
      : "PAYMENT IN PROCESS";
    this.urlElementsArray.push(arrivalDate);
    this.reservationClass.formReservation.traveldate1 = arrivalDate;
    this.urlElementsArray.push(departureDate);
    this.reservationClass.formReservation.traveldate2 = departureDate;
    this.urlElementsArray.push(daysCruise);
    this.reservationClass.formReservation.daycruise = daysCruise;
    this.urlElementsArray.push(optionCruise);
    this.reservationClass.formReservation.opccruise = optionCruise;
    this.urlElementsArray.push(String(numberAdults));
    this.reservationClass.formReservation.numberadult = String(numberAdults);
    this.urlElementsArray.push(String(numberChild));
    this.reservationClass.formReservation.numberchild = String(numberChild);
    this.urlElementsArray.push(`${comments}-${automaticTextNotification}`);
    this.reservationClass.formReservation.comments = `${comments}-${automaticTextNotification}`;
    this.urlElementsArray.push("en");
    this.reservationClass.formReservation.languaje = "en";

    return `${arrivalDate}/${departureDate}/${daysCruise}/${optionCruise}/${numberAdults}/${numberChild}/${comments}/en/`;
  }

  setUtms() {
    // START SET UTMS
    this.reservationClass.formReservation.utm.utmsource =
      this.getCokieValue("source");
    this.reservationClass.formReservation.utm.utmmedium =
      this.getCokieValue("medium");
    this.reservationClass.formReservation.utm.utmcampaign =
      this.getCokieValue("campaign");
    this.reservationClass.formReservation.utm.utmterm =
      this.getCokieValue("term");
    this.reservationClass.formReservation.utm.utmadg =
      this.getCokieValue("adgroup");
    this.reservationClass.formReservation.utm.utmmtp =
      this.getCokieValue("matchtype");
    this.reservationClass.formReservation.utm.utmcon =
      this.getCokieValue("content");
    this.reservationClass.formReservation.utm.utmad = this.getCokieValue("ad");
    this.reservationClass.formReservation.utm.utmkey =
      this.getCokieValue("keyword");
      this.reservationClass.formReservation.utm.utmext =
      this.getCokieValue("extension");
      this.reservationClass.formReservation.utm.utmplace =
      this.getCokieValue("placement");
    this.reservationClass.formReservation.utm.urlorigen =
      this.getUrlOrigenCokieValue("url_origen");
    // END SET UTMS
  }

  getCokieValue(value: string) {
    return Cookies.get(value) === undefined || Cookies.get(value) === null
      ? "none"
      : Cookies.get(value);
  }

  getUrlOrigenCokieValue(value: string) {
    return Cookies.get(value) === undefined || Cookies.get(value) === null
      ? window.location.href
      : Cookies.get(value);
  }
  getContactInfoRoyal(): string {
    let fName =
      this.purchaseRequestService.getPurchaseContactPerson().firstName;
    let lName = this.purchaseRequestService.getPurchaseContactPerson().lastName;
    let email = this.purchaseRequestService.getPurchaseContactPerson().email;
    let phone =
      isNullOrUndefined(
        this.purchaseRequestService.getPurchaseContactPerson().phone
      ) || this.purchaseRequestService.getPurchaseContactPerson().phone === ""
        ? "Not specific"
        : this.purchaseRequestService.getPurchaseContactPerson().phone;
    let country =
      this.purchaseRequestService.getPurchasePassengersInformation()[0].country;
    let agency =
      this.purchaseRequestService.getPurchaseContactPerson().agency === ""
        ? "Not specific"
        : this.purchaseRequestService.getPurchaseContactPerson().agency;
    let reference = this.purchaseRequestService.getPurchaseContactPerson()
      .lastName
      ? this.purchaseRequestService.getPurchaseContactPerson().lastName
      : "Not specific";
    this.urlElementsArray.push(fName);
    this.reservationClass.formReservation.firstname = fName;
    this.urlElementsArray.push(lName);
    this.reservationClass.formReservation.lastname = lName;
    this.urlElementsArray.push(email);
    this.reservationClass.formReservation.email = email;
    this.urlElementsArray.push(phone);
    this.reservationClass.formReservation.phone = phone;
    this.urlElementsArray.push(country);
    this.reservationClass.formReservation.country = country;
    this.urlElementsArray.push(agency);
    this.reservationClass.formReservation.agencyname = agency;
    this.urlElementsArray.push(reference);
    this.reservationClass.formReservation.referencename = reference;
    this.cruise.availability[this.itineraryIndex].aditionalServices.forEach((additionalService)=>{
      this.reservationClass.formReservation.additionalServices.push(additionalService.replace("+ ",""))
    });
    this.reservationClass.formReservation.pricePerPerson = this.purchaseRequestService.getPricePerPerson().toString();


    return `${fName}/${lName}/${email}/${phone}/${country}/${agency}/${reference}/`;
  }
  getInterestDataRoyal(): string {
    let interestString = "";
    interestString = "0/0/0/0/";
    this.urlElementsArray.push("0");
    this.urlElementsArray.push("0");
    this.urlElementsArray.push("0");
    this.urlElementsArray.push("0");

    return interestString;
  }

  public getPromoName(itineraryIndex: number): string {
    try {
      return (
        this.promoService.getPromoText(
          this.cruise.availability[itineraryIndex].promotionType,
          this.cruise.availability[itineraryIndex].promotionValue
        ) || ""
      );
    } catch (error) {
      console.log("ResultsComponent.getPromoName()");
      console.error(error);
      return null;
    }
  }
  getStringFormDatailRoyal(promoText: string): string {
    let product = this.royalRequestService.getNameBoatToRoyal(this.cruise.name);
    let resp = "none" + "/" + product + "/" + promoText + "/";
    this.urlElementsArray.push("none");
    this.reservationClass.formReservation.services = "none";
    this.urlElementsArray.push(product);
    this.reservationClass.formReservation.product = product;
    this.urlElementsArray.push(promoText);
    this.reservationClass.formReservation.promotion = promoText;
    // let resp = (services === "" ? "none" : services.substring(0, services.length - 1)) + "/" + product + "/" + promoText + "/";
    return resp;
  }

  private requestBookingConfirmation(): void {
    try {
      this.isProcessing = true;
      this.purchaseRequestService.requestBookingConfirmation().subscribe(
        (bookingConfirmationResponse: BookingConfirmationResponse) => {
          if (
            this.purchaseRequestService.isRequestBookingConfirmationSuccess(
              bookingConfirmationResponse
            )
          ) {
            this.purchaseRequestService.purchaseRequestStatus =
              PurchaseRequestStatus.BOOCKING_CONFIRMATION_SENT;

            this.requestRoyalForm(false);
          }
        },
        (error: any) => {
          this.isProcessing = false;
          console.log("BookTourComponent.requestbookingConfirm()");
          console.error(error);
          this.addlog(
            WebFlowAction.SEND_CONFIRMATION_EMAIL,
            //"error",
            { ...this.purchaseRequestService.preparePurchaseBookingConfirm() },

          );
        },
        () => {
          this.isProcessing = false;
        }
      );
    } catch (error) {
      console.log("BookTourComponent.requestbookingConfirm()");
      console.error(error);
    }
  }
  selectThirtyPercent() {
    this.isSelectedThirtyPercent = !this.isSelectedThirtyPercent;
    this.purchaseRequestService.setIsSelectedThirtyPerent(
      this.isSelectedThirtyPercent
    );
    this.purchaseTotalPrice = this.purchaseRequestService.getTotalPrice();
  }

  changeTermsPayTransfer(eventValue) {
    this.termsConditionPaytransfer = eventValue;
    this.valueTerms = eventValue ? "all" : "none";
    this.ngWebflowService.addWebFlowAction(WebFlowAction.CLICK_TERMS_CONDITIONS, {
      termsConditionPaytransfer: this.termsConditionPaytransfer,
    });
  }

  changePrivacyData(eventValue) {
    this.termsPrivacyData = eventValue;
    this.valueTerms = eventValue ? "all" : "none";
    this.ngWebflowService.addWebFlowAction(WebFlowAction.CLICK_TERMS_CONDITIONS, {
      termsPrivacyData: this.termsPrivacyData,
    });
  }

  private isOnTimeToPay(): void {
    try {
      this.serverDateService.requestServerDateAsString().subscribe(
        (serverDate: string) => {
          // const departureDeta: Date = new Date(this.cruiseWrapper.getCurrentItinerary()
          const departureDeta: Date = new Date(
            this.purchaseRequestService
              .getCruiseWrapper()
              .getCurrentItinerary().startDate
          );
          const msDifference =
            Number(departureDeta.getTime()) - Number(serverDate);
          const hoursDifference =
            UtilsService.millisecondsToHours(msDifference);
          const daysDifference = UtilsService.millisecondsToDays(msDifference);
          this.hasThirtyPercent =
            daysDifference < this.minDepartureTimeToEnableAutoPayment
              ? false
              : true;

          if (hoursDifference < this.minDepartureTimeToEnableAutoPayment) {
            this.isAutoPaymentAccepted = false;
            this.sendEmail();
          } else {
            this.isAutoPaymentAccepted = true;
          }
        },
        (error: any) => {
          console.error(error);
          this.isAutoPaymentAccepted = false;
        },
        () => {}
      );
    } catch (error) {
      console.error(error);
      this.isAutoPaymentAccepted = false;
    }
  }

  private sendEmail() {
    const myPurchase = this.purchaseRequestService.purchase as Purchase;
    console.log("--->sending automatic", myPurchase);
    this.ngWebflowService.addWebFlowAction(WebFlowAction.SENDING_AUTOMATIC_START, this.fillRequestDatatoInquire(myPurchase) );
    this.galavailServiceEcommer
      .sendInquireEmail(this.fillRequestDatatoInquire(myPurchase))
      .subscribe(
        (response) => {
          const result: boolean =
            this.contactFormService.isSendFormResponseSuccess(response);
          this.ngWebflowService.addWebFlowAction(WebFlowAction.SENDING_AUTOMATIC_SUCCESS, {
            result: {
              actionStatus: result,
              purchaseStatus: this.purchaseRequestService.purchaseRequestStatus,
            },
          });
          this.requestRoyalFormOverTime(true);
        },
        (errorResponse) => {
          this.ngWebflowService.addWebFlowAction(WebFlowAction.SENDING_AUTOMATIC_FAILED, {
            result: {
              actionStatus: true,
              purchaseStatus: this.purchaseRequestService.purchaseRequestStatus,
            },
          });
          console.error(errorResponse);
        }
      );
  }

  changePaymentMethod(i: number) {
    this.termsConditionPaytransfer = false;
    this.flagClick = false;
    // Limpiar cualquier respuesta de PlaceToPay anterior al cambiar de método de pago
    sessionStorage.removeItem('placetopay_payment_response');
    this.paymentMethods.forEach((item, index) => {
      if (index === i) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
    this.selectedCodePayment = this.paymentMethods[i];
    sessionStorage.setItem('selected_payment_method', JSON.stringify(this.selectedCodePayment));
    this.purchaseRequestService.setCodePaymentMethod(this.selectedCodePayment.code);
  }

  fillRequestDatatoInquire(purchase: Purchase): any {
    const startDate = purchase.cruise.availability[0].startDate.replace(
      " 12:00:00 AM",
      ""
    );
    const endDate = purchase.cruise.availability[0].endDate.replace(
      " 12:00:00 AM",
      ""
    );
    const objectResquest = {
      emailReceptor:
        this.companyParamsService.getCompanyParams().emailEcommerce,
      subject: "New Request",
      inquireDTO: {
        company: this.companyParamsService.getName(),
        boat: purchase.cruise.name,
        promotion: this.promoService.getPromoText(
          purchase.cruise.availability[0].promotionType,
          purchase.cruise.availability[0].promotionValue
        ),
        startDate,
        endDate,
        days: purchase.cruise.availability[0].length,
        opcDays: purchase.cruise.availability[0].name,
        adults: this.purchaseRequestService.getNumberOfAdults(),
        childs: this.purchaseRequestService.getNumberOfChildren(),
        commnets:
          "Given that your cruise will take place within the next 72 hours",
        interestFlights: true,
        interestAmazon: true,
        interestPeru: true,
        interestEcuador: true,
        lastName: purchase.purchaseContactPerson.lastName,
        firstName: purchase.purchaseContactPerson.firstName,
        email: purchase.purchaseContactPerson.email,
        phone: purchase.purchaseContactPerson.phone,
        country: "",
        interestPromos: false,
        reference: this.purchaseRequestService.getPurchaseContactPerson()
          .lastName
          ? this.purchaseRequestService.getPurchaseContactPerson().lastName
          : "Not specific",
        howFindUs: purchase.purchaseContactPerson.howFindUs,
        valueOther: purchase.purchaseContactPerson.valueOther,
        ipSender: this.geoIp,
      },
      company: {
        logoCompany: this.companyParamsService.getCompanyParams().logo,
        nameCompany: this.companyParamsService.getName(),
        mainColorCompany: this.companyParamsService.getMainColor(),
        secondaryColorCompany: this.companyParamsService.getSecundaryColor(),
        headerColorCompany: this.companyParamsService.getHeaderColor(),
        footerColorCompany: this.companyParamsService.getFooterColor(),
        infoMailCompany: this.companyParamsService.getInfoEmail(),
        phoneCompany: this.companyParamsService.getPhone(),
        webSiteCompany: this.companyParamsService.getWebSite(),
      },
    };
    return objectResquest;
  }
  public paymentComplete(paymentResponse: any, paymentType: PaymentType): void {
    try {
      this.isProcessing = true;
      // this.requestPostSpaces();
      this.purchaseRequestService.addPaymentResponse(
        paymentResponse,
        paymentType
      );
      this.isPaymentComplete = true;
      this.isPaymentCancel = false;
      this.isPaymentError = false;

      if (paymentType === PaymentType.PAYPAL) {
        this.setBookingTrackCode(paymentResponse.id);
      } else if (paymentType === PaymentType.payflowCreditCard) {
        const PayflowTransactionResponse: TransactionResponseInterface =
          paymentResponse as TransactionResponseInterface;
        this.setBookingTrackCode(PayflowTransactionResponse.getId());
      }

      this.purchaseRequestService.purchaseRequestStatus =
        PurchaseRequestStatus.PAYMENT_COMPLETED;
      const paymentData = {
        paymentResponse: paymentResponse,
        paymentType: paymentType,
      };
      this.addlog(
        WebFlowAction.EXECUTING_PAYMENT_COMPLETED,
        //"payment_completed",
        paymentData
      );
      this.requestBookingConfirmation();
    } catch (error) {
      this.isProcessing = false;
      console.error(error);
    }
  }

  private setBookingTrackCode(bookingTrackCode: string): void {
    try {
      this.purchaseRequestService.setTrackingCode(bookingTrackCode);
    } catch (error) {
      console.error();
    }
  }
  private initPayment(): void {}

  renderPaypalButton(
    htmlElementId: string,
    includeFundingButtons: boolean,
    label: string
  ): void {
    try {
      this.isProcessing = false;
      const paypalRequestObject: any = {
        style: this.getPayPalButtonStyleObject(includeFundingButtons, label),
        env: this.companyParamsService.getPayPalInfo().apiMode,
        client: {
          sandbox: this.companyParamsService.getPayPalInfo().clientSandboxToken,
          production:
            this.companyParamsService.getPayPalInfo().clientProductionToken,
        },
        funding: this.getPaypalFundingMethodsObject(),
        commit: true,
        payment: (data, actions) => {
          this.initPayment();
          return actions.payment.create(this.getPaypalPaymentObject());
        },
        onAuthorize: (data: any, actions: any) => {
          return actions.payment
            .get()
            .then((approvedPaymentResponse: PaypalPaymentResponse) => {
              this.isRequestingBlockDeparture = true;

              this.isProcessing = true;
              this.purchaseRequestService
                .requestBlockCabinOnHold(
                  this.purchaseRequestService.getPercentUsed()
                )
                .subscribe(
                  (blockDepartureResponse: BlockDeparture) => {
                    const isblockDeparture: boolean =
                      this.purchaseRequestService.setBlockDeparture(
                        blockDepartureResponse
                      );
                    this.isBlockDepartureSuccess =
                      isblockDeparture === true &&
                      this.purchaseRequestService.isRequestBlockDepartureSuccess();
                    if (this.isBlockDepartureSuccess === false) {
                      this.isBlockDepartureFailed();
                    } else {
                      return actions.payment.execute().then(
                        (executedPaymentResponse: PaypalPaymentResponse) => {
                          this.paymentComplete(
                            executedPaymentResponse,
                            PaymentType.PAYPAL
                          );
                        },
                        (error) => {
                          this.isRequestingBlockDeparture = false;
                          this.isBlockDepartureSuccess = false;
                          console.error(error);
                          this.isBlockDepartureFailed();
                        }
                      );
                    }
                    this.isRequestingBlockDeparture = false;
                  },
                  (error) => {
                    this.isRequestingBlockDeparture = false;
                    this.isBlockDepartureSuccess = false;
                    this.isProcessing = false;
                    console.log("PaymentOptionsComponent.blockDeparture()");
                    console.error(error);
                    this.isBlockDepartureFailed();
                  },
                  () => {
                    this.isRequestingBlockDeparture = false;
                  }
                );
            });
        },
        onCancel: (data, actions) => {
          this.paymentCanceled(data, actions);
        },
        onError: (error) => {
          this.paymentError(error);
        },
      };

      if (this.isConsoleLog) {
        console.log("paymentOptions.renderPaypalButton(): Request Object");
        console.log(paypalRequestObject);
      }

      paypal.Button.render(paypalRequestObject, "#" + htmlElementId);
    } catch (error) {
      console.log("PaymentOptionsCompoent.renderPaypalButton()");
      console.error(error);
    }
  }
  isProcessingMethod(event: any) {
    this.isProcessing = true;
  }
  private paymentError(error: any) {
    try {
      this.isPaymentComplete = false;
      this.isPaymentCancel = false;
      this.isPaymentError = true;
      if (
        this.purchaseRequestService.isRequestBlockDepartureSuccess() === true
      ) {
        this.unblockDeparture();
      }
      this.ngWebflowService.addWebFlowAction(WebFlowAction.EXECUTING_PAYMENT_PAYPAL_ERROR, {
        result: "error",
      });
    } catch (error) {
      console.log("PaymentOptionsComponent.paymentError()");
      console.error(error);
    }
  }
  private paymentCanceled(data: any, actions: any): void {
    try {
      this.isPaymentComplete = false;
      this.isPaymentCancel = true;
      this.isPaymentError = false;
      if (
        this.purchaseRequestService.isRequestBlockDepartureSuccess() === true
      ) {
        this.unblockDeparture();
      }
      this.ngWebflowService.addWebFlowAction(WebFlowAction.EXECUTING_PAYMENT_PAYPAL_CANCELED, {
        result: "canceled",
      });
    } catch (error) {
      console.log("PaymentOptionsComponent.paymentCanceled()");
      console.error(error);
    }
  }
  private unblockDeparture(): void {
    try {
      this.purchaseRequestService.requestUnblockDeparture().subscribe(
        (unblockDepartureResponse: UnblockDeparture) => {
          const isUnblockDeparture: boolean =
            this.purchaseRequestService.setUnblockDeparture(
              unblockDepartureResponse
            );
          const isUnblockDepartureSuccess: boolean =
            isUnblockDeparture === true &&
            this.purchaseRequestService.isRequestUnblockDepartureSuccess();
          if (isUnblockDepartureSuccess === false) {
            this.isUnblockDepartureFailed();
          } else {
            this.isBlockDepartureSuccess = undefined;
          }
        },
        (error) => {
          console.log("PaymentOptionsComponent.unblockDeparture()");
          console.error(error);
          this.isUnblockDepartureFailed();
        },
        () => {}
      );
    } catch (error) {
      console.log("PaymentOptionsComponent.unblockDeparture()");
      console.error(error);
      this.isBlockDepartureSuccess = false;
      this.isUnblockDepartureFailed();
      throw error;
    }
  }
  private isUnblockDepartureFailed(): void {
    // TODO do something
  }

  private getPaypalFundingMethodsObject(): any {
    return {
      allowed: [
        paypal.FUNDING.CREDIT,
        paypal.FUNDING.CARD,
        paypal.FUNDING.ELV,
        paypal.FUNDING.VENMO,
        paypal.FUNDING.IDEAL,
      ],
    };
  }
  private getPayPalButtonStyleObject(
    includeFundingButtons: boolean,
    label: string
  ): {
    fundingicons: boolean;
    size: string;
    shape: string;
    label: string;
    tagline: boolean;
    layout: string;
  } {
    return {
      fundingicons: includeFundingButtons,
      size: "small",
      shape: "rect",
      label: label,
      tagline: false,
      layout: "horizontal",
    };
  }
  private getPaypalPaymentObject(): any {
    return {
      payment: {
        intent: this.companyParamsService.getPayPalInfo().requestIntent,
        transactions: [
          {
            amount: {
              total: this.purchaseTotalPrice,
              currency: this.companyParamsService.getPayPalInfo().currency,
            },
            // description: this.purchaseRequestService.getPurchaseDescription(),
            // invoice_number: '487875896735',
            // soft_descriptor: this.purchaseRequestService.getPurchaseDescriptor(),
            // custom: 'AN ID OR SOMETHING46'
            item_list: this.isSelectedThirtyPercent
              ? {
                  items:
                    this.purchaseRequestService.getPaypalItemsWithThirtyPercent(
                      this.purchaseTotalPrice
                    ),
                }
              : {
                  items: this.purchaseRequestService.getPaypalItems(),
                },
          },
        ],
        note_to_payer:
          this.purchaseRequestService.getPurchaseShortDescription(),
      },
      experience: {
        input_fields: {
          no_shipping: 1,
        },
      },
    };
  }
  isBlockDepartureFailed() {
    this.isProcessing = false;
  }

  private initializeBoatImageResource(): void {
    this.boatImagesResource =
      environment.app_resources.logoCruise + this.cruise.image;
  }
  changeTerms(eventValue) {
    this.termsCondition = eventValue;
    this.valueTerms = eventValue ? "all" : "none";
  }

  getImagesByType(code: number): PaymentsType[] {
    return this.paymentsTypeService.getPaymentsByType(code);
  }

  //its use the enum to control the names web flow actions
  addlog( titleAction: WebFlowAction, data: any) {
    this.ngWebflowService.addWebFlowAction(titleAction, {
      message: data,
    });
  }

  getStripePayment(): any {
    try {
      const index = this.companyParamsService.company.paymentMethods.findIndex(
        (item) =>
          Number(item.type) === Number(PaymentMethodTypeEnum.STRIPE_CHECKOUT)
      );

      return index || index === 0
        ? this.companyParamsService.company.paymentMethods[index]
        : undefined;
    } catch (error) {}
  }

  cabinWasReservedOrHttpError(event: any) {
    if (event === ResponseOnHold.RESERVED_ERROR) {
      this.purchaseRequestService.setTypeErrorOnHold(false);
      this.requestBookingConfirmationAutomatic(false);
    } else {
      this.purchaseRequestService.setTypeErrorOnHold(true);
      this.requestBookingConfirmationAutomatic(true);
    }
    this.ngWebflowService.addWebFlowAction(WebFlowAction.BOOKING_FAILED, {
                  message: 'booking failed' }
    );
    this.isProcessing = false;
  }

  requestBookingConfirmationAutomatic(isPaymentError: boolean) {
    const AUTOMATIC_NOTIFICATION = true;
    if (this.counterSuccessAutomaticEmail === 0) {
      this.purchaseRequestService
        .requestInquireConfirm(AUTOMATIC_NOTIFICATION, isPaymentError)
        .subscribe((resp) => {
          this.counterSuccessAutomaticEmail++;
        });
    }
  }


  /** Todo lo migrado Stripe **/

  executeWithStripe() {
    this.paymentOption = PaymentOption.STRIPE;
    const paymentMethodStripe:PaymentMethod | undefined = this.stripeService.paymentMethodStripe();
    if (!paymentMethodStripe) {
      return;
    }

    // Bandera que indica si ya se obtuvo un token de Stripe (es decir, si el
    // pago realmente inició). Stripe dispara `closed` tanto cuando se genera un
    // token como cuando el usuario cierra el popup sin completar el pago.
    let paymentInProgress = false;

    const paymentHandler = (<any>window).StripeCheckout.configure({
      key: paymentMethodStripe.objectConfiguration.stripeKey,
      locale: 'auto',
      token: (stripeToken: any) => {
        paymentInProgress = true;
        paymentstripe(stripeToken);
      },
    });
    this.getUrlRequest(false);
    const paymentstripe = async (stripeToken: any) => {
      this.stripeService.auditPaymentStripe(AuditStep.START);
      const request: IStripe = this.stripeService.paymentstripe(stripeToken,this.purchaseTotalPrice, this.purchaseRequestService.getDescriptionStripe());
      this.stripeService.processPaymentstripe(request, this.reservationClass,this.companyParamsService.getName()).then((resultProcess) => {
      if(resultProcess){
            const { error, type, data  } = resultProcess;
            if(error) {
              if(type === ResponseOnHold.PAYMENT_ERROR) {
                this.stripeService.auditPaymentStripe(AuditStep.ERROR, data);
                this.typeErrorPaymentStripe = ResponseOnHold.PAYMENT_ERROR;
                this.attemptPaymentStripe ++;
              } else if(type === ResponseOnHold.RESERVED_ERROR) {
                this.stripeService.auditPaymentStripe(AuditStep.ERROR_BLOCK, data);
                this.typeErrorPaymentStripe = ResponseOnHold.RESERVED_ERROR;
              }
            } else {
              this.attemptPaymentStripe = 0;
              this.stripeService.auditPaymentStripe(AuditStep.PAYMENT, data);
              this.getUrlRequest(false);
              this.nextFourthPart();
            }
      }
      this.paymentOption = PaymentOption.NONE;
      });
    }

    paymentHandler.open({
      name: 'CHECKOUT',
      description: 'Payment method',
      amount: this.purchaseTotalPrice * 100,
      // `closed` es el evento propio de Stripe Checkout que se dispara al cerrar
      // la ventana (popup). Se dispara en dos casos:
      //  1. Tokenización exitosa (el pago ya comenzó): no reseteamos, porque el
      //     procesamiento async de `paymentstripe` seguirá mostrando "Please
      //     Wait" y luego resetea `paymentOption` a NONE al terminar.
      //  2. El usuario cierra el popup sin completar el pago: reseteamos
      //     `paymentOption` a NONE para sacar el botón de "Please Wait" y
      //     permitir un nuevo intento de pago, continuando el flujo normal.
      closed: () => {
        if (!paymentInProgress) {
          this.paymentOption = PaymentOption.NONE;
        }
      },
    });
  }


/**
 * Metodo que valida si se muestra el mensaje de error de bloqueo de cabina
 * @returns true si se muestra el mensaje de error de bloqueo de cabina
 */
  isVisibleMessageErrorBlockDeparture() {
    if(this.placetopayOnHoldResponse === true && this.isAutoPaymentAccepted === true && this.isBlockDepartureSuccess !== undefined && this.isBlockDepartureSuccess === false) return true;
    if(this.placetopayOnHoldResponse === true && this.isAutoPaymentAccepted === true && this.stripeService.viewMessageErrorReserved(this.typeErrorPaymentStripe)) return true;
    return false;
  }


/***********************************************************
 ****************** PLACETOPAY METHODS *********************
 **********************************************************/
 isVisibleMessageErrorBlockPlacetopay() {
  if(this.placetopayOnHoldResponse === false ) {
    return true;
  }
  return false;
 }

  onExecutePaymentLightbox() { //Metodo para iniciar el pago con Lightbox
    // Guardar datos antes de redirigir al procesador de pagos
      this.saveDataBeforePaymentRedirect();
    // No permitir crear nueva sesión si el pago ya fue aprobado
    if (this.placetopayPaymentApproved) {
      console.log('PlaceToPay: Pago ya aprobado, no se puede crear nueva sesión');
      return;
    }
    this.initPlacetopayPaymentLightbox();
  }

  onPaymentClosedLightbox() {
    console.log('El usuario cerró el Lightbox');
    this.attemptPaymentPlacetopay++;
    // No resetear loading si el pago ya fue aprobado (mantener procesando hasta redirección)
    if (this.placetopayPaymentApproved) {
      console.log('PlaceToPay: Pago aprobado, manteniendo estado de carga');
      return;
    } else {
      this.placetopayLoading = false; // Resetear loading para permitir nuevo intento
      this.paymentOption = PaymentOption.NONE; // Resetear opción de pago
      console.log('Intento de pago PlaceToPay:', this.attemptPaymentPlacetopay);
    }
  }

  /**
   * Maneja cuando PlaceToPay está bloqueado (JavaScript deshabilitado o CSP)
   */
  onPlacetopayBlocked(errorMsg: string) {
    console.log('PlaceToPay bloqueado:', errorMsg);
    this.placetopayLoading = false;
    // Don't reset paymentOption to allow the warning dialog to persist
    // this.paymentOption = PaymentOption.NONE;
  }

  /**
   * Verifica si se ha excedido el número de intentos de pago con PlaceToPay
   */
  exceededAttemptsPlacetopay(): boolean {
    return this.attemptPaymentPlacetopay >= ConfiguracionPagoTarjeta.intentos_pago_placetopay;
  }

  /**
   * Obtiene el mensaje de error cuando se exceden los intentos de PlaceToPay
   */
  getPlacetopayAttemptsErrorMessage(): string {
    return `You have exceeded the maximum number of payment attempts (${ConfiguracionPagoTarjeta.intentos_pago_placetopay}). Please contact us at ${this.companyParamsService.getInfoEmail()} for assistance.`;
  }


  async onPaymentResponseLightbox(response: MerchantNotificationRequest) {
    console.log('Respuesta de PlaceToPay-Front:', response);
    // Asignar la respuesta del lightbox para mostrar en checkout-fourth
    this.placetopayPaymentRequest = response;
    // Consultar el backend de PlaceToPay para obtener los datos finales de la transacción
    if (response.requestId) {
      try {
        const sessionResult = await this.placetopayService.processPaymentPlacetopay(this.companyParamsService.generateKeyCompanyByName(),response.requestId.toString());
        if (sessionResult && sessionResult.data) {
          console.log('Datos de sesión PlaceToPay obtenidos del backend:', sessionResult.data);
          const sessionData = sessionResult.data;
          // Estado efectivo: primero se verifica si existe informacion de pago (payment[0].status);
          // si no existe pago, se toman los datos del objeto status de la sesión.
          const effectiveStatus = sessionResult.status || sessionData.status;
          const effectiveStatusValue = effectiveStatus ? effectiveStatus.status : response.status.status;
          const payment = sessionData.payment && sessionData.payment.length ? sessionData.payment[0] : null;

          if (payment) {
            const paymentAmount = payment.amount && payment.amount.from && payment.amount.from.total
              ? payment.amount.from.total
              : sessionData.amount;
            const paymentCurrency = payment.amount && payment.amount.from && payment.amount.from.currency
              ? payment.amount.from.currency
              : 'USD';
            const transactionData = {
              reference: payment.reference,
              dateTime: (effectiveStatus && effectiveStatus.date) || new Date().toISOString(),
              status: effectiveStatusValue,
              amount: paymentAmount,
              currency: paymentCurrency,
              authorization: payment.authorization || '',
            };
            // Persistir en el objeto purchase
            this.purchaseRequestService.setTransactionData(transactionData);
            console.log('PlaceToPay: transactionData persistido desde statusOnHold:', transactionData);

            if (effectiveStatusValue === PlacetopayPaymentStatus.REJECTED || effectiveStatusValue === PlacetopayPaymentStatus.FAILED) {
              const reason = (effectiveStatus && effectiveStatus.reason) || 'Unknown reason';
              const message = (effectiveStatus && effectiveStatus.message) || 'No message provided';
              const date = (effectiveStatus && effectiveStatus.date) || new Date().toISOString();
              const errorDetails = `Payment rejected or failed. Reason: ${reason}. Message: ${message}. Date: ${date}`;
              this.purchaseRequestService.setErrorPayment(errorDetails);
            }
          }

          // Actualizar placetopayPaymentRequest con el estado efectivo (pago > sesión)
          if (effectiveStatus) {
            this.placetopayPaymentRequest = {
              ...this.placetopayPaymentRequest,
              status: {
                status: effectiveStatusValue,
                reason: effectiveStatus.reason || (this.placetopayPaymentRequest.status && this.placetopayPaymentRequest.status.reason),
                message: effectiveStatus.message || (this.placetopayPaymentRequest.status && this.placetopayPaymentRequest.status.message),
                date: effectiveStatus.date || (this.placetopayPaymentRequest.status && this.placetopayPaymentRequest.status.date)
              }
            };
          }
        }
      } catch (e) {
        console.error('Error obteniendo datos de sesión PlaceToPay:', e);
      }
    }

    // Manejar los diferentes estados del pago
    switch (this.placetopayPaymentRequest.status.status) {
      case PlacetopayPaymentStatus.APPROVED:
        this.handlePaymentApproved();
        break;
      case PlacetopayPaymentStatus.PENDING:
        this.handlePaymentPending();
        break;
      case PlacetopayPaymentStatus.REJECTED:
      case PlacetopayPaymentStatus.FAILED:
        this.handlePaymentRejected();
        break;
      case PlacetopayPaymentStatus.ERROR:
      default:
        this.handlePaymentError(this.placetopayResult && this.placetopayResult.error);
        break;
    }
  }

  private createPaymentSessionRequest() : PlacetopayCreateSessionRequest {
        const purchase = this.purchaseRequestService.purchase;
        const contactPerson = purchase.purchaseContactPerson;
        // Generar referencia única para la transacción
        const reference = this.generatePaymentReference();
        // Construir URLs de retorno usando router.url
        const baseUrl = window.location.origin;
        const currentPath = this.router.url;
        // Construir URLs de éxito y cancelación basadas en la ruta actual
        const returnUrl = `${baseUrl}${currentPath}/success`;
        const cancelUrl = `${baseUrl}${currentPath}/cancel`;

        let userIp = '0.0.0.0';
        this.geoip2Service.getGeoIpDirection().subscribe((geoIp: string) => {
          userIp = geoIp;
        });
        // Construir la solicitud de sesión de pago
        const sessionRequest: PlacetopayCreateSessionRequest = {
          reference: reference,
          description: `Cruise reservation ${purchase.cruise.name} - ${purchase.cruise.availability[0].name}`,
          amount: this.purchaseTotalPrice,
          currency: 'USD',
          returnUrl: returnUrl,
          cancelUrl: cancelUrl,
          payer: {
            documentType: 'PPN',
            documentNumber: contactPerson.passport || '00000000',
            name: contactPerson.firstName,
            surname: contactPerson.lastName,
            email: contactPerson.email,
            mobile: contactPerson.phone || ''
          },
          keyCompany:this.companyParamsService.generateKeyCompanyByName(),
          ipAddress: userIp,
        };
        return sessionRequest;
  }

   /**
   * Inicia el pago con PlaceToPay.
   * Flujo: 1) Crear sesión, 2) Crear status temporal, 3) Abrir Lightbox
   * Nota (Regla 2, solo PlaceToPay): al aprobarse el pago NO se ejecuta el onHold
   * ni el sendConfirmationEmail (ver handlePaymentApproved).
   */
  private async initPlacetopayPaymentLightbox(): Promise<void> {
    this.placetopayLoading = true;
    // Nuevo intento: se reinicia la espera del resultado del servicio de consulta
    this.placetopayWaitingStatus = false;
    this.paymentOption = PaymentOption.PLACETOPAY; // Establecer opción de pago para controlar loading
    try {
      const sessionRequest = this.createPaymentSessionRequest();
      console.log('PlaceToPay: Iniciando sesión de pago:', sessionRequest);

      // Guardar la referencia generada para usarla en el onHold después
      this.purchaseRequestService.setPlacetopayReference(sessionRequest.reference);

      // 1. Crear la sesión de pago
      const result = await this.placetopayService.createPaymentSessionAsync(sessionRequest);

      if (result.success && result.processUrl) {
        // Guardar el requestId para verificar el pago al retornar
        this.placetopaySessionId = result.requestId;
        sessionStorage.setItem('placetopay_requestId', result.requestId);
        sessionStorage.setItem('placetopay_reference', sessionRequest.reference);

        console.log('PlaceToPay: Sesión creada exitosamente:', result.processUrl);

        // 2. Crear status temporal (statusPlacetopayPaymentAsync) antes de abrir lightbox
        const itinerary = this.purchaseRequestService.getCruiseWrapper()
          .getCruise()
          .availability[this.purchaseRequestService.getCruiseWrapper().getCurrentItineraryIndex()].code.toString();
        // Usar la misma referencia de PlaceToPay para el jsonOnHold
        const jsonOnHold = this.purchaseRequestService.getJsonOnHoldForPlacetopay(
          this.purchaseRequestService.getPercentUsed(),
          sessionRequest.reference // Pasar la referencia de PlaceToPay
        );
        console.log('PlaceToPay: Creando status temporal con jsonOnHold:', jsonOnHold);
        const paymentID = parseInt(result.requestId, 10);

        // --- Llenar transactionData con datos de la sesión ---
        const transactionData = {
          reference: sessionRequest.reference,
          dateTime: new Date().toISOString(),
          status: 'PENDING',
          amount: sessionRequest.amount,
          currency: sessionRequest.currency,
          authorization: '', // Se llenará después del pago
        };
        jsonOnHold.transactionData = transactionData;
        // Persistir en el objeto purchase
        this.purchaseRequestService.setTransactionData(transactionData);

        console.log('PlaceToPay: Creando status temporal con referencia:', sessionRequest.reference);
        const jsonSendConfirmationMail = this.purchaseRequestService.preparePurchaseBookingConfirm();
        const jsonSendInquireRequestEmail = this.fillRequestDatatoInquire(this.purchaseRequestService.purchase);
        const statusResult = await this.placetopayService.statusPlacetopayPaymentAsync(
          itinerary,
          jsonOnHold,
          paymentID,
          jsonSendConfirmationMail,
          jsonSendInquireRequestEmail,
        );

        if (statusResult.success && statusResult.data && statusResult.data.status === true) {
          console.log('PlaceToPay: Status temporal creado exitosamente:', statusResult);
          // Guardar el transaction para usarlo en cancelación si es necesario
          this.purchaseRequestService.setValueTransaction(statusResult.data.message);

          // 3. Abrir el Lightbox para que el usuario complete el pago
          // Nota (Regla 2, solo PlaceToPay): al aprobarse el pago NO se ejecuta el onHold ni el sendConfirmationEmail.
          this.placetopayComponent.openLightbox(result.processUrl);
        } else {
          // Error al crear status temporal - la cabina pudo haber sido reservada
          const errorMessage = (statusResult.data && statusResult.data.message) || statusResult.error || 'Error creating status';
          console.error('PlaceToPay: Error al crear status temporal:', errorMessage);
          this.isPaymentError = true;
          this.placetopayLoading = false;
          this.paymentOption = PaymentOption.NONE;
          this.cabinWasReservedOrHttpError(ResponseOnHold.RESERVED_ERROR);
        }
      } else {
        console.error('PlaceToPay: Error al crear sesión:', result.error);
        this.isPaymentError = true;
        this.placetopayLoading = false;
        this.paymentOption = PaymentOption.NONE;
      }
    } catch (error) {
      console.error('PlaceToPay: Error inesperado:', error);
      this.isPaymentError = true;
      this.placetopayLoading = false;
      this.paymentOption = PaymentOption.NONE;
    }
  }

  /**
   * Genera una referencia única para el pago
   */
  private generatePaymentReference(): string {
    const reference = this.purchaseRequestService.getReferencePlacetopay();
    const timestamp = Date.now();
    const referenceWithTimestamp = `${reference}-${timestamp}`;
    return referenceWithTimestamp.slice(0, 32); // Limitar a 32 caracteres
  }

  /**
   * Maneja el estado de pago aprobado.
   * Ejecuta el onHold (requestBlockCabinOnHold) para bloquear la cabina definitivamente,
   * luego envía el email de confirmación y redirige.
   */
  private async handlePaymentApproved(): Promise<void> {
    try {
      // Marcar el pago como aprobado para evitar nuevas sesiones
      this.placetopayPaymentApproved = true;
      // Mantener loading activo durante todo el proceso
      this.placetopayLoading = true;
      // Guardar la respuesta del pago en sessionStorage para mostrarla en checkout-fourth
      if (this.placetopayPaymentRequest) {
        sessionStorage.setItem('placetopay_payment_response', JSON.stringify(this.placetopayPaymentRequest));
      }

      console.log('PlaceToPay: Pago aprobado.');

      // Regla 2 (solo PlaceToPay): cuando el estado cambia a APPROVED NO se invoca
      //   - el servicio onHold (requestG_blockCabin / royalWSAPI/onHold), ni
      //   - el servicio sendConfirmationEmail (requestG_bookingConfirm / royalWSAPI/sendConfirmationMail).
      // Solo se marca el pago como completado y se redirige a la confirmación.

      // Marcar pago como completado
      this.isPaymentComplete = true;
      this.isPaymentError = false;
      this.isPaymentCancel = false;
      this.isBlockDepartureSuccess = true;
      this.purchaseRequestService.purchaseRequestStatus = PurchaseRequestStatus.PAYMENT_COMPLETED;

      // Log de éxito
      this.addlog(WebFlowAction.EXECUTING_PAYMENT_SUCCESS, 'PlaceToPay payment approved');

      // Enviar formulario Royal si aplica (no es onHold ni sendConfirmationEmail)
      this.requestRoyalFormForPlacetopay();

      // Redirigir a la página de confirmación
      this.nextFourthPart();
    } catch (error) {
      console.error('PlaceToPay: Error en handlePaymentApproved:', error);
      this.placetopayLoading = false;
      this.paymentOption = PaymentOption.NONE;
      this.isPaymentError = true;
      this.isPaymentComplete = false;
      this.isBlockDepartureSuccess = false;
      this.addlog(WebFlowAction.ON_HOLD, 'PlaceToPay: Error processing approved payment - ' + error);
    }
    this.placetopayPaymentApproved = false;
  }

  /**
   * Versión simplificada de requestRoyalForm para PlaceToPay
   */
  private requestRoyalFormForPlacetopay(): void {
    if (this.companyParamsService.getName() === "Royal Galapagos") {
      this.getUrlRequest(false);
      this.royalRequestService.requestPost(this.reservationClass.formReservation).subscribe(
        (response) => {
          console.log('PlaceToPay: Royal form enviado exitosamente');
        },
        (error) => {
          console.error('PlaceToPay: Error al enviar Royal form:', error);
        }
      );
    }
  }

   /**
   * Maneja el estado de pago pendiente.
   * Mantiene el botón desactivado con el indicador "Please Wait" y consulta
   * el servicio de estado de PlaceToPay periódicamente hasta obtener APPROVED o REJECTED.
   */
  private handlePaymentPending(): void {
    this.isPaymentComplete = false;
    this.isPaymentError = false;
    this.isPaymentCancel = false;
    this.placetopayLoading = true;
    // Queda en espera del resultado del servicio de consulta (PENDING -> APPROVED/REJECTED)
    this.placetopayWaitingStatus = true;
    console.log('PlaceToPay: Pago pendiente de confirmación, iniciando consulta de estado...');
    this.startPlacetopayStatusPolling();
  }

  /**
   * Consulta periódicamente el estado de la sesión de PlaceToPay mientras el pago esté PENDING.
   * Cuando el servicio responde APPROVED o REJECTED, detiene la consulta y continua el proceso normal.
   */
  private startPlacetopayStatusPolling(): void {
    // Evitar múltiples consultas simultáneas
    if (this.placetopayPollingInterval) {
      console.log('PlaceToPay: Ya existe una consulta de estado activa');
      return;
    }

    const requestId = this.placetopaySessionId;
    if (!requestId) {
      console.error('PlaceToPay: No hay requestId para consultar el estado del pago');
      this.placetopayLoading = false;
      this.placetopayWaitingStatus = false;
      this.paymentOption = PaymentOption.NONE;
      return;
    }

    this.placetopayLoading = true;
    console.log('PlaceToPay: Iniciando consulta de estado cada', ConfiguracionPagoTarjeta.intervalo_consulta_placetopay_ms, 'ms para requestId:', requestId);

    this.placetopayPollingInterval = setInterval(async () => {
      try {
        const result = await this.placetopayService.processPaymentPlacetopay(
          this.companyParamsService.generateKeyCompanyByName(),
          requestId
        );

        // Estado efectivo resuelto por el servicio de consulta:
        // payment[0].status si existe informacion de pago, si no el objeto status de la sesión.
        if (result && result.status && result.status.status) {
          const status = result.status.status;
          console.log('PlaceToPay: Estado consultado:', status, '(origen:', result.statusSource, ')');

          if (status === PlacetopayPaymentStatus.APPROVED) {
            this.stopPlacetopayStatusPolling();
            this.updatePlacetopayPaymentRequestStatus(result.status);
            await this.handlePaymentApproved();
          } else if (status === PlacetopayPaymentStatus.REJECTED || status === PlacetopayPaymentStatus.FAILED) {
            this.stopPlacetopayStatusPolling();
            this.updatePlacetopayPaymentRequestStatus(result.status);
            await this.handlePaymentRejected();
          }
          // Si sigue PENDING, continuar con la siguiente consulta
        }
      } catch (error) {
        console.error('PlaceToPay: Error consultando estado durante la espera:', error);
      }
    }, ConfiguracionPagoTarjeta.intervalo_consulta_placetopay_ms);
  }

  /**
   * Actualiza el estado del pago mostrado en app-status-payment.
   */
  private updatePlacetopayPaymentRequestStatus(status: any): void {
    if (this.placetopayPaymentRequest && status) {
      this.placetopayPaymentRequest = {
        ...this.placetopayPaymentRequest,
        status: {
          status: status.status,
          reason: status.reason || (this.placetopayPaymentRequest.status && this.placetopayPaymentRequest.status.reason),
          message: status.message || (this.placetopayPaymentRequest.status && this.placetopayPaymentRequest.status.message),
          date: status.date || (this.placetopayPaymentRequest.status && this.placetopayPaymentRequest.status.date)
        }
      };
    }
  }

  /**
   * Detiene la consulta periódica del estado de PlaceToPay.
   */
  private stopPlacetopayStatusPolling(): void {
    // La espera del resultado del servicio termina al detener la consulta
    this.placetopayWaitingStatus = false;
    if (this.placetopayPollingInterval) {
      clearInterval(this.placetopayPollingInterval);
      this.placetopayPollingInterval = null;
      console.log('PlaceToPay: Consulta de estado detenida');
    }
  }

  /**
   * Maneja el estado de pago rechazado.
   * Nota (solo PlaceToPay): el status temporal (statusOnHoldPlaceToPay) NO se cancela
   * explícitamente desde el frontend. El polling consulta el estado de la sesión y el
   * backend resuelve la liberación cuando la sesión queda REJECTED/FAILED (o expira).
   */
  private async handlePaymentRejected(): Promise<void> {
    this.isPaymentComplete = false;
    this.isPaymentError = true;
    this.isPaymentCancel = false;
    console.log('PlaceToPay: Pago rechazado.');

    // Regla 1 (solo PlaceToPay): cuando el estado cambia a REJECTED no se invoca el servicio sendInquireRequestEmail.
    // Ya NO se llama a cancelStatusOnHoldPlaceToPay: el polling/backend resuelve la liberación del status temporal.

    this.placetopayLoading = false;
    this.paymentOption = PaymentOption.NONE;
    this.addlog(WebFlowAction.EXECUTING_PAYMENT_FAILED, 'PlaceToPay payment rejected');
  }

  /**
   * Maneja errores en el proceso de pago
   */
  private handlePaymentError(error: any): void {
    this.isPaymentComplete = false;
    this.isPaymentError = true;
    this.isPaymentCancel = false;
    this.placetopayLoading = false;
    this.placetopayWaitingStatus = false;
    this.paymentOption = PaymentOption.NONE;
    this.placetopayResult = {
      error: error
    };
    console.error('PlaceToPay: Error en el pago:', error);
  }

  goBack() {
    console.log('goBack')
    this.location.back();
  }

  goError(){
    this.router.navigate(['/error']);
  }

    /**
   * Inicializa el componente con datos restaurados desde sessionStorage
   */
  private initializeFromRestoredData(): void {
    try {
      this.isPaymentComplete = true;
      this.activeEndSlide = "active";
      this.isSelectedThirtyPercent = false;

      const selecteIndex = 0;
      this.paymentMethods = this.companyParamsService.getPaymentMethods();
      if (this.paymentMethods) {
        this.paymentMethods.forEach((item, index) => {
          item.selected = false;
        });
      }

      this.cruise = this.purchaseRequestService.purchase.cruise;
      if (this.cruise && this.cruise.availability) {
        this.availavilitySelected = this.cruise.availability[selecteIndex];
        this.purchaseTotalPrice = this.purchaseRequestService.getTotalPrice();
        this.allValuePrice = this.purchaseRequestService.getTotalPrice();
        this.onlyThirtyPrice = Math.round(
          this.allValuePrice *
            (this.companyParamsService.getPercentPartialPayment() / 100)
        );

        const iterIndex = this.cruise.iterIndex || 0;
        this.cruiseStartDate = this.cruise.availability[iterIndex].date;
        this.startEndDates = this.cruise.availability[iterIndex].startEndDates;
        this.startEndDatesType = this.cruise.availability[iterIndex].name;
        this.promotion = this.cruise.availability[iterIndex].promotion;
        this.itineraryIndex = selecteIndex;
        this.priceWithAirFare = this.cruiseService.getCruisePriceinNewFormat(
          this.cruise,
          this.itineraryIndex,
          true
        );
        this.initializeBoatImageResource();
        this.position = true;
      }
    } catch (error) {
      console.error('Error initializing from restored data:', error);
      this.isPaymentComplete = true;
      this.activeEndSlide = "active";
    }
  }

    /**
   * Consulta el estado del pago en PlaceToPay y maneja los diferentes estados
   */
  private async checkPlacetopayPaymentStatus(): Promise<void> {
    // Recuperar el requestId guardado antes de la redirección
    const storedSessionId = sessionStorage.getItem('placetopay_requestId');
    console.log('Checking PlaceToPay payment status for requestId:', storedSessionId);
    if (storedSessionId) {
      this.placetopaySessionId = storedSessionId;
    } else {
      this.goBack();
      return;
    }

    // Marcar que venimos desde redirección externa
    this.isReturnFromExternalRedirect = true;

    // Seleccionar automáticamente el método de pago PlaceToPay
    this.selectPlacetopayPaymentMethod();

    // Recuperar la respuesta de pago guardada en sessionStorage para mostrarla en app-status-payment
    const storedPaymentResponse = sessionStorage.getItem('placetopay_payment_response');
    const selectedPaymentMethod:PaymentMethod = JSON.parse(sessionStorage.getItem('selected_payment_method') || '{}');
    this.purchaseRequestService.setCodePaymentMethod(selectedPaymentMethod.code);

    if (storedPaymentResponse) {
      try {
        this.placetopayPaymentRequest = JSON.parse(storedPaymentResponse);
        console.log('PlaceToPay: Respuesta de pago recuperada desde sessionStorage:', this.placetopayPaymentRequest);
      } catch (e) {
        console.error('Error parseando placetopay_payment_response:', e);
      }
    }

    this.placetopayLoading = true;
    try {
      console.log('*****************************************************************************')
      // Una sola consulta al servicio de estado (antes se ejecutaba la misma petición dos veces)
      this.placetopayResult = await this.placetopayService.processPaymentPlacetopay(
        this.companyParamsService.generateKeyCompanyByName(),
        storedSessionId
      );
      console.log('PlaceToPay session result:', this.placetopayResult);
      console.log('*****************************************************************************')

      if (!this.placetopayResult || !this.placetopayResult.data) {
        throw (this.placetopayResult && this.placetopayResult.error) || new Error('PlaceToPay: respuesta de sesión vacía');
      }

      const sessionData = this.placetopayResult.data;
      // Estado efectivo: primero se verifica si existe informacion de pago (payment[0].status);
      // si no existe pago, se toman los datos del objeto status de la sesión.
      const effectiveStatus = this.placetopayResult.status || sessionData.status;
      const effectiveStatusValue = effectiveStatus ? effectiveStatus.status : null;
      console.log('PlaceToPay: estado efectivo:', effectiveStatusValue, '(origen:', this.placetopayResult.statusSource, ')');

      const payment = sessionData.payment && sessionData.payment.length ? sessionData.payment[0] : null;
      if (payment) {
        const paymentAmount = payment.amount && payment.amount.from && payment.amount.from.total
          ? payment.amount.from.total
          : sessionData.amount;
        const paymentCurrency = payment.amount && payment.amount.from && payment.amount.from.currency
          ? payment.amount.from.currency
          : 'USD';
        const transactionData = {
          reference: payment.reference,
          dateTime: (effectiveStatus && effectiveStatus.date) || new Date().toISOString(),
          status: effectiveStatusValue,
          amount: paymentAmount,
          currency: paymentCurrency,
          authorization: payment.authorization || '',
        };
        this.purchaseRequestService.setTransactionData(transactionData);
        console.log('Updated purchase with transactionData:', transactionData);
      }

      // Construir el request mostrado en app-status-payment si todavía no existe
      if (!this.placetopayPaymentRequest) {
        this.placetopayPaymentRequest = {
          requestId: parseInt(storedSessionId, 10),
          status: effectiveStatus,
          reference: sessionData.request && sessionData.request.payment ? sessionData.request.payment.reference : '',
          signature: ''
        };
        console.log('PlaceToPay: Construyendo placetopayPaymentRequest desde sessionResult:', this.placetopayPaymentRequest);
      }
      // Mantener sincronizado el estado mostrado en app-status-payment (pago > sesión)
      if (effectiveStatus) {
        this.updatePlacetopayPaymentRequestStatus(effectiveStatus);
      }

      // Cuando viene desde redirección externa, mostrar el componente app-status-payment primero
      // y procesar el pago después de un pequeño delay para que el usuario vea el estado
      if (this.isReturnFromExternalRedirect) {
        console.log('PlaceToPay: Retorno desde redirección externa, mostrando estado del pago...');
        // Resetear loading para que se muestre el componente app-status-payment
        this.placetopayLoading = false;

        // Procesar el pago después de 2 segundos para que el usuario vea el estado
        setTimeout(() => {
          this.handlePaymentStatusFromExternalRedirect(effectiveStatusValue);
        }, 2000);
      } else {
        // Flujo normal (lightbox): manejar inmediatamente
        switch (effectiveStatusValue) {
          case PlacetopayPaymentStatus.APPROVED:
            this.handlePaymentApproved();
            break;

          case PlacetopayPaymentStatus.PENDING:
            this.handlePaymentPending();
            break;

          case PlacetopayPaymentStatus.REJECTED:
          case PlacetopayPaymentStatus.FAILED:
            this.handlePaymentRejected();
            break;

          case PlacetopayPaymentStatus.ERROR:
          default:
            this.handlePaymentError(this.placetopayResult.error);
            break;
        }
      }
    } catch (error) {
      console.error('Error checking PlaceToPay payment status:', error);
      this.handlePaymentError(error);
      this.placetopayLoading = false;
    }
  }

  /**
   * Maneja el estado del pago cuando viene desde redirección externa de PlaceToPay
   */
  private handlePaymentStatusFromExternalRedirect(status: string): void {
    console.log('PlaceToPay: Procesando estado del pago desde redirección externa:', status);
    this.placetopayLoading = true;

    switch (status) {
      case PlacetopayPaymentStatus.APPROVED:
        this.handlePaymentApproved();
        break;

      case PlacetopayPaymentStatus.PENDING:
        this.handlePaymentPending();
        break;

      case PlacetopayPaymentStatus.REJECTED:
      case PlacetopayPaymentStatus.FAILED:
        this.handlePaymentRejected();
        break;

      case PlacetopayPaymentStatus.ERROR:
      default:
        this.handlePaymentError(this.placetopayResult ? this.placetopayResult.error : 'Unknown error');
        break;
    }
  }

  /**
   * Guarda los datos del purchase y company antes de redirigir al procesador de pagos
   */
  public saveDataBeforePaymentRedirect(): void {
    this.purchaseRequestService.savePurchaseToSession();
    this.companyParamsService.saveCompanyToSession();
  }

  /**
   * Selecciona automáticamente el método de pago PlaceToPay
   */
  private selectPlacetopayPaymentMethod(): void {
    if (this.paymentMethods && this.paymentMethods.length > 0) {
      const placetopayIndex = this.paymentMethods.findIndex(
        item => item.type === PaymentMethodTypeEnum.PLACETOPAY
      );
      if (placetopayIndex !== -1) {
        console.log('PlaceToPay: Seleccionando método de pago PlaceToPay automáticamente');
        // Deseleccionar todos los métodos de pago
        this.paymentMethods.forEach((item, index) => {
          item.selected = (index === placetopayIndex);
        });
      }
    }
  }

}


